//NB! feature flags are not the same as Scoro features. Feature flags are meant for releasing things, Scoro features for pricing.
export const FeatureFlag = {
	COMMENT_REACTIONS: 'comment_reactions',
	CUSTOM_MODULES_PACKAGING: 'custom_modules_packaging',
	VIRTUAL_ASSISTANT: 'virtual_assistant',
	HAS_REFERRAL: 'has_referral',
	PROJECT_MODIFY_POPUP: 'project_modify_popup',
	DUMMY_TEST_FLAG: 'dummy_test_flag',
	INTERNAL_PROJECT_BILLABLE_TIME: 'internal_project_billable_time',
	PROJECT_HEALTH: 'project_health',
	ELI_ACTION_BUTTONS: 'eli_action_buttons',
	ALL_TIME_ENTRIES_BILLABLE: 'all_time_entries_billable',
	PRICING_SERVICE_ENABLED: 'pricing_service_enabled',
};
